import { render } from "./PropertyListAgent.vue?vue&type=template&id=64749ad5"
import script from "./PropertyListAgent.vue?vue&type=script&lang=js"
export * from "./PropertyListAgent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__